const ValidUserCheck = (state = "false", action) => {
    switch (action.type) {
        case 'VALID_USER_CHECK_FAIL':
            if (action?.msg) return action?.msg
        default:
            return state
    }
}
export default ValidUserCheck
